import React from 'react';
import { MotifIcon, MotifIconButton, MotifTooltip } from '@ey-xd/motif-react';
import { IconoirEditPencil, IconoirTrash } from '@ey-xd/motif-icon';

function renderDeleteButton(props, onDeleteClick) {
  const isDeleteEnabled = props.data?.canDeleteProperty;
  const deleteButton = (
    <MotifIconButton
      aria-label="Delete this Property"
      type="button"
      onClick={onDeleteClick}
      data-testid="btnDeleteProperty"
      disabled={!isDeleteEnabled}
    >
      <MotifIcon
        iconFunction={IconoirTrash}
        size="24"
        title="Delete this Property"
      />
    </MotifIconButton>
  );

  if (!isDeleteEnabled) {
    return (
      <MotifTooltip
        trigger={deleteButton}
        allowClick={false}
        hideCloseButton={true}
      >
        {`The property cannot be deleted because it may have a PSQ or a Trial Balance uploaded, or a System Generated Security. The earliest period this condition exists is in ${props.data.earliestPeriod}.`}
      </MotifTooltip>
    );
  }

  return deleteButton;
}

function renderEditButton(props, onEditClick) {
  const editButton = (
    <MotifIconButton
      aria-label="Edit this Property"
      type="button"
      onClick={onEditClick}
      data-testid="btnEditProperty"
    >
      <MotifIcon
        iconFunction={IconoirEditPencil}
        size="24"
        title="Edit this Property"
      />
    </MotifIconButton>
  );

  return editButton;
}

const MasterDataManagementPropertiesCellRenderer = (props) => {
  const onEditClick = () => {
    if (props.handleEditButtonClick) {
      props.handleEditButtonClick(props.data);
    }
  };

  const onDeleteClick = () => {
    if (props.handleDeleteButtonClick) {
      props.handleDeleteButtonClick(props.data);
    }
  };

  return (
    <div>
      {props.column.colId === 'editactions' && (
        <span className="mt-2">{renderEditButton(props, onEditClick)}</span>
      )}

      {props.column.colId === 'deleteactions' && (
        <span className="mt-2">{renderDeleteButton(props, onDeleteClick)}</span>
      )}
    </div>
  );
};

export default MasterDataManagementPropertiesCellRenderer;
